import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaskDirective } from './src/mask.directive';
import { MaskService } from './src/mask.service';

@NgModule({
  exports: [
    MaskDirective
  ],
  declarations: [
    MaskDirective
  ],
  providers: [
    MaskService
  ]
})
export class Ng4InputMaskModule { }



// WEBPACK FOOTER //
// /root/anvel/angular/app/services/input-mask/ng4-input-mask.module.ts